import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import BackArrow from "src/atoms/backArrow/backArrow";
import axios from "axios";
import PlusIcon from "src/assets/images/plusIcon.svg";
import { set } from "date-fns";
import CheckTick from "src/assets/images/checked-tick.svg";
import { makeAPICall } from "src/services/apiService";
import PageLoader from "src/atoms/pageLoader";

const CashTypePayment = () => {
  const [respData, setRespData] = useState(null);
  const [tranId , setTranId] = useState();
  const [initiatedOBJ, setInitiatedOBJ] = useState();
  const [documents, setDocuments] = useState([]);
  const [fileName, setFileName] = useState("");
  const [showToggle, setShowToggle] = useState(false);
  const [submitDisable, setSubmitDisable] = useState(true);
  const [toastMsg, setToastMsg] = useState("");
  const [uploadData, setUploadData] = useState(null);
  const [fileChange,setFileChange] = useState(false);
  const [loading, setLoading] = useState(false);
  const userInfo = JSON.parse(sessionStorage.getItem("user_details"));
  const history = useHistory();
  const location = useLocation();

  const { order_id, user_id } = location.state || {};

  const toggleToaster = (msg, time = 2000) => {
    setShowToggle(true);
    setToastMsg(msg);
    setTimeout(() => {
      setShowToggle(false);
      setToastMsg("");
    }, time);
  };

  const getOfflineSplits = async (id, user_id) => {
    console.log("Inside CashTypePayment id , user_id : ", id, user_id);
    let offlineSplitsPayload = {
      method: "get",
      url: "api/offlinePayment/getOfflineSplits",
      params: {
        orderId: id,
        customer_uuid: user_id,
      },
    };
    console.log(
      "Inside CashTypePayment offlineSplitsPayload : ",
      offlineSplitsPayload
    );
    await makeAPICall(offlineSplitsPayload)
      .then((resp) => {
        const initiated = resp?.data?.all_payment_transactions.find(
          (status) => status.approval_status === "INITIATED"
        );
        console.log("Inside CashTypePayment initiated : ", initiated);

        //Start
        if (initiated) {
          setLoading(true);
          setInitiatedOBJ(initiated);
          axios
            .get(
              `api/offlinePayment/getTransactionDetails?order_id=${initiated?.order_id}`
            )
            .then((res) => {
              console.log("getTransactionDetails :::: ", res);
              const resdocument = res?.data?.documents;
              const tran_id = res?.data?.transaction_id;
              setTranId(tran_id);
              console.log("document :::: ", resdocument);
              setDocuments(resdocument);
              setLoading(false);
            })
            .catch((err) => {
              console.log("getTransactionDetails err ::::", err);
              setLoading(false);
            });
        }

        // console.log("resp in getOfflineSplits", resp)
        // const sttOrder = resp.data?.all_payment_transactions;
        // setsttOrder(sttOrder);
        // console.log("sttOrder", sttOrder);
        // resolve("success");
      })
      .catch((err) => {
        console.log("error in getting offlineSplits Payload", err);
      });
  };

  const handleUpload = async (file) => {
    uploadData.data.transaction_id = tranId;//initiatedOBJ?.transaction_id;
    console.log(`Tran 1 : ${initiatedOBJ?.transaction_id}  , Tran 2 : ${tranId}`);
    console.log("uploadData :: ",uploadData);
    makeAPICall(uploadData)
      .then((resp) => {
        if (resp && resp.data?.status === "SUCCESS") {
          console.log("the upload response is : ", resp);
          toggleToaster("File Uploaded Successfully");
          setTimeout(() => {  history.push("/cash-type"); }, 2000);     
          
        }
      })
      .catch((err) => {
        console.log("The handleUpload error is : ",err);
        toggleToaster("File Upload Failed");
      });

    // let TARGET_URL = "https://us-central1-pmap-1490493535970.cloudfunctions.net/uploadFileToDrive"
    // if (!file) {
    //   //setErrorMessage('Please select a valid file before uploading.');
    //   return;
    // }
    // const formData = new FormData();
    // formData.append('file', file);
    // formData.append('fileName', fileName); // Send custom file name
    // console.log("file", file)
    // try {
    //   const response = await axios.post(TARGET_URL, formData, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   });
    //   console.log('File uploaded successfully:', response.data);
    //   debugger
    //   setDocuments(null); // Reset file after successful upload
    //   setFileName(''); // Reset file name after successful upload
    // } catch (err) {
    //   console.error('Error uploading file:', err);
    //   //setErrorMessage('Error uploading file. Please try again.');
    // }
  };

  const saveEachDocument = (type, file, ind) => {
    let index = type.split(`OFFLINE_PAYMENT_`)[1];
    let fileBody = {
      file: file,
      type: index == 1 ? "OFFLINE_PAYMENT" : type,
      view: "FRONT",
      data: {},
      is_address_proof: false,
    };

    let uploadBody = {
      address_proof: "",
      already_uploaded: false,
      order_id: order_id,
      files: [fileBody],
    };
    console.log("The uploadBody : ",uploadBody)
    let config = {
      method: "PUT",
      url: `api/offlinePayment/postingOfflinePaymentFile`,
      params: {
        ...userInfo,
        customer_uuid: user_id,
      },
      data: { ...uploadBody },
    };
    console.log("upload data config : ", config);
    setUploadData(config);
  };

  const onFileChange = async (evt) => {
    setFileChange(true);
    setSubmitDisable(false);
     let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic|\.heif)$/i;
    const [documents] = evt.target?.files;
    setDocuments(documents)
    //setFileName(state?.order_id || state?.number || 'FILE_UPLOADED')
    let extension = documents?.name.substr(documents?.name.lastIndexOf("."));
    let size = parseFloat(documents?.size / (1024 * 1024)).toFixed(2);
    console.log('size:', size)
    if (allowedExtensions.exec(extension)) {
      console.log('90890asd:', size)
      if (size <= 7) {
        let reader = new FileReader();
        let base64Version = '';
        reader.readAsDataURL(documents);
        reader.onload = async function () {
          base64Version = reader.result;
          if(base64Version) {
            saveEachDocument("OFFLINE_PAYMENT", base64Version, 0);
          }
        };
        if (documents) {
          if (extension?.toLowerCase() == ".pdf" || extension?.toLowerCase() == ".heic" || extension?.toLowerCase() == ".heif") {
            document.getElementById('preview-img').src = CheckTick
            document.getElementById('preview-img').style.width = "20%"
            document.getElementById('preview-img').style.left = "38%"
          }
          else {
            document.getElementById('preview-img').style.width = "50%"
            document.getElementById('preview-img').style.left = "0"
          }
        }
      } else {
        toggleToaster("Please upload images less than 7 mb")
      }
    }
    else {
      setSubmitDisable(true);
      setDocuments([]);
      toggleToaster("Please upload images of type(jpeg,jpg,png,heic,heif)")
    }
  };

  useEffect(() => {
    getOfflineSplits(order_id, user_id);
  }, []);

 

  return (
    <div className="cashTypePay-container">
       {loading && <PageLoader />}
      <div className="cashTypePay-header-div">
        <div
          onClick={() => {
            history.push("/cash-type");
          }}
        >
          <BackArrow />
        </div>
        <div className="cashTypePay-header">
          Pending/Failed Cash Transaction
        </div>
      </div>
      {initiatedOBJ && (
        <div className="cashTypePay-bottom-div">
          <div className="cashTypePay-user-name-orderid">
            <div className="cashTypePay-user-name">Order ID</div>
            <div className="cashTypePay-userid">{initiatedOBJ?.order_id}</div>
          </div>
          <div className="cashTypePay-user-name-orderid">
            <div className="cashTypePay-user-name">Payment Type</div>
            <div className="cashTypePay-userid">Cash</div>
          </div>
          <div className="cashTypePay-user-name-orderid">
            <div className="cashTypePay-user-name">Amount</div>
            <div className="cashTypePay-userid">₹ {initiatedOBJ?.amount}</div>
          </div>
        </div>
      )}

      <div className="uploadImgWrapper">
        <div className="uploadImage">
          {documents && documents.length == 0 ? (
            <img className="plus-icon" src={PlusIcon} alt="" />
          ) : (
            <img
              src= {fileChange? URL.createObjectURL(documents) : documents[0]?.file }
              style={{ width: "100%", height: "160px" }}
            ></img>
          )}
          <input
            className="input-file"
            id="uploadInput"
            type="file"
            data     
            //disabled={documents && documents.length >= 3}
            onInput={(evt) => onFileChange(evt)}
            onClick={(event) => {
              if (!document) {
                event.target.value = null; 
              }
              else if (documents && documents.length >= 3) {
                event.preventDefault();            
                toggleToaster("Maximum Upload Limit Reached");  
              }
            }}
          />
        </div>
        <div
          style={{ display: documents ? "block" : "none" }}
          className="upload-preview-img"
        >
          <img className="previewImg" id="preview-img" src="#" alt="" />
        </div>
      </div>

      <div className="initiate-payment-btn-div">
        <button
          disabled={submitDisable}
          className={`${submitDisable?"disableBtnClass" : " "} initiate-payment-btn`}
          onClick={() => {
            handleUpload(documents);
          }}
        >
          Submit
        </button>
      </div>
      {showToggle && <div className="toaster">{toastMsg}</div>}
    </div>  
  );
};

export default CashTypePayment;
